// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0d3f0649","453":"88bae978","455":"b928d6ef"}[chunkId] + ".chunk.js";
};